<template>
  <div id="about">
    <div class="container">
      <div class="row">
        <div class="col">
          <hr />
          <h1>
            Welcome to <span>IMEJ Tech.com</span> &ndash; Get the Ball Rolling
            <a href="#/" class="logo-link">
              <img src="../assets/logo.svg" id="logo" alt="logo" />
              <div></div>
            </a>
          </h1>
          <hr />
          <br>
          <h4>
            At IMEJ Tech.com, we Live the life we love and love the life we live. By
            creating the greatest websites and online presence possible for you.
            We are looking to fullfill your vision, your needs, and your wants,
            let's getting the ball rolling.
          </h4>
          <br />
          <hr />
          <router-link class="btn btn-md btn-success" to="/Contact">
            <i class="fas fa-phone-volume"></i> Contact Us
            <i class="fas fa-phone-volume"></i></router-link>
          <br>
          <hr />
          <br>
          <h4>
            <i class="fas fa-award"></i> Web Design &amp; Development
            <i class="fas fa-award"></i>
            <br />
            <br />
          </h4>
          We take your concepts and ideas very seriously and make them into a
          reality. We have extensive knowledge in the latest CSS with responsive
          design elements, HTML5, JavaScript, as well as the latest content
          management systems.
          <hr />
          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  components: {},
};
</script>

<style scoped>
#logo {
  height: 20px;
  padding-left: 0px;
}
#about {
  background-image: url("../assets/screen-5.png");
  background-size: cover;
  background-position: center;
  animation: backgroundMove 120s ease-in-out infinite;
}
hr {
  background-color: #e3e6e6;
}
.btn.btn-success,
#ajax-contact-form input.btn {
  background-color: black;
  box-shadow: 0px 4px 0px 0px #007bff;
}
.btn.btn-success:hover {
  color: #007bff;
}
.col {
  background-color: #232f3e;
  background-image: url("https://www.transparenttextures.com/patterns/black-orchid.png");
}
h1 {
  color: white;
}
h4,
#about,
#text {
  color: white;
  font-size: 20px;
}
span {
  color: white;
}

@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
